import { render, staticRenderFns } from "./CommunitiesComp.vue?vue&type=template&id=771b3cb4&scoped=true&"
import script from "./CommunitiesComp.vue?vue&type=script&lang=js&"
export * from "./CommunitiesComp.vue?vue&type=script&lang=js&"
import style0 from "./CommunitiesComp.vue?vue&type=style&index=0&id=771b3cb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b3cb4",
  null
  
)

export default component.exports